import React from 'react';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

function EmailOptionCard({ selected, onSelect, label, description }) {
  return (
    <div
      className={`publish-option-card ${selected ? 'is-selected' : ''}`}
      onClick={onSelect}
    >
      <div
        className={`publish-option-radio ${selected ? 'is-selected' : ''}`}
      />
      <div>
        <div className="publish-option-label">{label}</div>
        <div className="publish-option-desc">{description}</div>
      </div>
    </div>
  );
}

export default function SyllabusUploadStepStudentEmails({
  value,
  onChange,
  onBack,
  onConfirm,
  loading,
}) {
  const sendEmails = value?.sendStudentsSuggestedReadingsEmail !== false;

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            Should students get news suggestions by email?
          </div>
          {/* <p className="syllabus-step-desc mt-1">
            We can send students a weekly email with links to their assigned
            readings.
          </p> */}
        </div>
        <div className="section-con">
          <EmailOptionCard
            selected={sendEmails}
            onSelect={() => onChange({ ...value, sendStudentsSuggestedReadingsEmail: true })}
            label="Yes"
            description="Students get a weekly email with links to this week's readings."
          />
          <EmailOptionCard
            selected={!sendEmails}
            onSelect={() => onChange({ ...value, sendStudentsSuggestedReadingsEmail: false })}
            label="No"
            description="Students access readings through the course page only."
          />
        </div>
        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <RectangularButton onClick={onBack} disabled={loading}>
              Back
            </RectangularButton>
            <RectangularButton
              darkButton
              onClick={onConfirm}
              disabled={loading}
            >
              Finish
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}
